<h3 class="title-divider-suche">{{ "Projektstatus" | translate }}</h3>
<cap-form-row class="col-md-12">
  <div class="col-md-3">
    <cap-form-control labelKey="Alle">
      <input
        (change)="selectAll()"
        (ngModelChange)="model && (model.sucheAlle = $event)"
        [ngModel]="model && model.sucheAlle"
        name="projektstatusSelection.sucheAlle"
        type="checkbox" />
    </cap-form-control>
  </div>
  <div class="col-md-9">
    <cap-form-control labelKey="Annulliert">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheAnnulliert = $event)"
        [ngModel]="model && model.sucheAnnulliert"
        name="projektstatusSelection.sucheAnnulliert"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="BaugesuchBeantragt">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheBeantragt = $event)"
        [ngModel]="model && model.sucheBeantragt"
        name="projektstatusSelection.sucheBeantragt"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="BaugesuchBewilligt">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheBewilligt = $event)"
        [ngModel]="model && model.sucheBewilligt"
        name="projektstatusSelection.sucheBewilligt"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="ProjektBaubegonnen">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheBaubegonnen = $event)"
        [ngModel]="model && model.sucheBaubegonnen"
        name="projektstatusSelection.sucheBaubegonnen"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="ProjektAbgeschlossen">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheAbgeschlossen = $event)"
        [ngModel]="model && model.sucheAbgeschlossen"
        name="projektstatusSelection.sucheAbgeschlossen"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="ProjektSistiert">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheSistiert = $event)"
        [ngModel]="model && model.sucheSistiert"
        name="projektstatusSelection.sucheSistiert"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="BaugesuchAbgelehnt">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheAbgelehnt = $event)"
        [ngModel]="model && model.sucheAbgelehnt"
        name="projektstatusSelection.sucheAbgelehnt"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="ProjektNichtRealisiert">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheNichtRealisiert = $event)"
        [ngModel]="model && model.sucheNichtRealisiert"
        name="projektstatusSelection.sucheNichtRealisiert"
        type="checkbox" />
    </cap-form-control>
    <cap-form-control labelKey="ProjektZurueckgezogen">
      <input
        (change)="selectOne($event)"
        (ngModelChange)="model && (model.sucheZurueckgezogen = $event)"
        [ngModel]="model && model.sucheZurueckgezogen"
        name="projektstatusSelection.sucheZurueckgezogen"
        type="checkbox" />
    </cap-form-control>
  </div>
</cap-form-row>
